import produce from 'immer';
import { SHOW, HIDE } from './action-types';

const initialState = {
  isVisible: false,
  text: '',
};

export type ToastStateType = typeof initialState;

export default produce((draft: ToastStateType, action) => {
  switch (action.type) {
    case SHOW:
      draft.isVisible = true;
      draft.text = action.payload.text;
      break;
    case HIDE:
      draft.isVisible = false;
      draft.text = '';
      break;
    default:
    // nothing
  }
}, initialState);
